module.exports = __webpack_public_path__ + "img/up.96d78fa9.svg";